<form [formGroup]="affiliateForm" (ngSubmit)="saveForm()" #ngForm="ngForm">
  <div class="row g-3">
    <div class="form-group col-md-12">
      <label for="name" class="required">Affiliate Name (Max 45 characters)</label>
      <input type="text" class="form-control mt-2" formControlName="name" placeholder="" maxlength="45"
        [ngClass]="{'invalid' : name.invalid && ngForm.submitted}" />

      <div class="col-md-12 formspace mt-4">
        <label for="description" class="required">Description (Max 250 characters)</label>
        <textarea class="form-control mt-2" formControlName="description" placeholder="" maxlength="250"
          [ngClass]="{'invalid' : description.invalid && ngForm.submitted}"> </textarea>
      </div>
    </div>

    <div class="form-group col-md-6">
      <label for="hrefText" class="required">Registration link text</label>
      <!-- @todo: update type to url here -->
      <input type="text" class="form-control mt-2" formControlName="hrefText" placeholder="" maxlength="25"
        [ngClass]="{'invalid' : hrefText.invalid && ngForm.submitted}" />
    </div>


    <div class="form-group col-md-6">
      <label for="hrefLink" class="required">Registration link (URL, include http://)</label>
      <input type="text" class="form-control mt-2" formControlName="hrefLink" placeholder="" maxlength="250"
        [ngClass]="{'invalid' : hrefLink.invalid && ngForm.submitted}" />
    </div>

    <div class="col-md-12 formspace mt-4">
      <label for="imageUrl" class="form-label required">Upload Affiliate Image</label>
      <div class="row">
        <div class="col-md-6 mt-1">
          <input type="text" formControlName="imageFileName" class="form-control" id="imageFileName"
            placeholder="Select a .jpg or a .png file"
            [ngClass]="{'invalid' : imageFileName.invalid && ngForm.submitted}">
        </div>
        <div class="col-md-6">
          <div class="file-btn-wrapper">
            <button type="button" class="btn btn-outline-primary"> {{isEdit ? 'Change.. ' : 'Browse..'}}</button>
            <input type="file" name="file" (change)="fileChange($event)" accept="image/*" id="logoUpload" />
          </div>
        </div>
      </div>
    </div>

    <div class="center mt-5">
      <button type="submit" class="btn btn-primary mb-3" [disabled]="isProcessing">Save</button>
    </div>
  </div>
</form>